function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.32725 0.416789C8.12727 0.216815 7.80305 0.216816 7.60308 0.416789L4.34433 3.67554C4.14436 3.87551 4.14436 4.19973 4.34433 4.3997C4.5443 4.59968 4.86852 4.59968 5.0685 4.3997L7.4531 2.0151L7.4531 6.53982C7.4531 6.82262 7.68236 7.05188 7.96516 7.05188C8.24797 7.05188 8.47722 6.82262 8.47722 6.53982L8.47723 2.0151L10.8618 4.3997C11.0618 4.59968 11.386 4.59968 11.586 4.3997C11.786 4.19973 11.786 3.87551 11.586 3.67554L8.32725 0.416789ZM7.64489 15.6328C7.84486 15.8328 8.16908 15.8328 8.36905 15.6328L11.6278 12.3741C11.8278 12.1741 11.8278 11.8499 11.6278 11.6499C11.4278 11.4499 11.1036 11.4499 10.9036 11.6499L8.51903 14.0345L8.51903 9.50981C8.51903 9.227 8.28978 8.99774 8.00697 8.99774C7.72417 8.99774 7.49491 9.227 7.49491 9.50981L7.49491 14.0345L5.11031 11.6499C4.91033 11.4499 4.58611 11.4499 4.38614 11.6499C4.18617 11.8499 4.18617 12.1741 4.38614 12.3741L7.64489 15.6328Z",
  fill: "currentColor"
});

var SvgIcExpand = function SvgIcExpand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcExpand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_expand.feab9067.svg";
export { ForwardRef as ReactComponent };